/** used to check if all keys in an object have values defined
 * Use numberOfProps to define how many props the object should have
 */
const allDefined = (props: any, numberOfProps?: number) => {
    if (numberOfProps) {
        if (!props) {
            return false;
        }
        if (Object.keys(props).length !== numberOfProps) {
            return false;
        }
    }
    for (const prop in props) {
        if (!prop || !props[prop]) {
            return false;
        }
    }
    return true;
};
const allValid = (errorMessages: any) => {
    for (const msg in errorMessages) {
        if (errorMessages[msg]) {
            return false;
        }
    }
    return true;
};
export { allDefined, allValid };
